export const GET_REPORT_LOGS: string = 'GET_REPORT_LOGS'
export const GET_REPORT_LOGS_SUCCESS: string = 'GET_REPORT_LOGS_SUCCESS'
export const GET_REPORT_LOGS_FAILURE: string = 'GET_REPORT_LOGS_FAILURE'
export const GET_REPORT_LOG_DETAILS: string = 'GET_REPORT_LOG_DETAILS'
export const GET_REPORT_LOG_DETAILS_SUCCESS: string =
  'GET_REPORT_LOG_DETAILS_SUCCESS'
export const GET_REPORT_LOG_DETAILS_FAILURE: string =
  'GET_REPORT_LOG_DETAILS_FAILURE'



// WEBPACK FOOTER //
// ./src/constants/report.constant.ts